import React from 'react';
import BaseTable, { AutoResizer } from 'react-base-table';
import { TableWrapper, StyledBaseTable } from './styled';

export const Table = ({ style = {}, ...tableProps }) => {
  return (
    <TableWrapper style={style}>
      <AutoResizer>
        {({ width, height }) => <StyledBaseTable width={width} height={height} {...tableProps} />}
      </AutoResizer>
    </TableWrapper>
  );
};

export const AnchoredTable = ({ style = {}, ...tableProps }) => {
  return (
    <TableWrapper style={style}>
      <AutoResizer>
        {({ width, height }) => <BaseTable width={width} height={height} {...tableProps} />}
      </AutoResizer>
    </TableWrapper>
  );
};

export default Table;

export {
  default as RefForwardedTable,
  type RefForwardedTableProps,
  type RefForwardedTableRef,
} from './RefForwardedTable';
